<script>
/* COMPOSANTS */
import AkLoader from '@components/general/AkLoader.vue';
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';
import AkSidebar from '@components/v2/general/AkSidebar.vue';
import GaMessages from '@components/ga/layout/GaMessages.vue';
import AkFormSubmitted from '@components/general/AkFormSubmitted';
import AkDropdown from '@components/v2/input/AkDropdown';
import AkButtonFooterSidebar from '@components/v2/general/AkButtonFooterSidebar.vue';

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';
import messageMixin from '@mixins/messageMixin';
import mailTemplateConst from '@mixins/const/mailTemplateConst';

/* SERVICES */
import mailTemplateService from '@services/mailTemplateService';

export default {
  components: {AkButtonValidation, AkLoader, AkDropdown, AkFormSubmitted, AkSidebar, GaMessages, AkButtonFooterSidebar},
  mixins: [utilsMixin, messageMixin, mailTemplateConst],
  data() {
    return {
      messages: [],
      submitted: false,
      sidebarVisible: false,
      mailTemplate: {},
    };
  },
  emits: ['updated'],
  mounted() {},
  methods: {
    show(data) {
      this.mailTemplate = {...data};
      this.sidebarVisible = true;
      this.submitted = false;
    },
    hide() {
      this.mailTemplate = {};
      this.sidebarVisible = false;
    },
    update() {
      this.messages = [];
      this.submitted = true;

      mailTemplateService
        .update(this.mailTemplate)
        .then((data) => {
          this.success(this.$t('mail_template.updated'));
          this.$emit('updated', data);
          this.hide();
        })
        .catch((e) => {
          this.$refs.footerSidebar.init();
          const msg = this.msgForErr(this.$t, e);
          this.$refs.sidebarMessages.error(msg);
        });
    },
  },
};
</script>

<template>
  <AkSidebar
    v-model:visible="sidebarVisible"
    :baseZIndex="9998"
    :dismissable="true"
    @hide="hide"
    block-scroll
    position="right">
    <template #container>
      <div class="mb-4">
        <GaMessages ref="sidebarMessages" />
      </div>
      <div class="p-sidebar-header">
        <div class="p-sidebar-header-content">{{ $t('mail_template.update') }}</div>
        <button class="p-sidebar-close p-sidebar-icon p-link" type="button" @click="hide">
          <span
            class="p-sidebar-close-icon ga-icon ga-close_circle text-4xl text-grey-400 md:hover:text-grey-900 md:hover:bg-transparent" />
        </button>
      </div>
      <div class="p-sidebar-content">
        <perfect-scrollbar class="h-full flex flex-col gap-4 md:gap-2 pr-7" :options="{suppressScrollX: true}">
          <AkFormSubmitted :submitted="submitted" reference="form">
            <div class="flex flex-col gap-2">
              <AkDropdown
                v-model="mailTemplate.technicalName"
                filter
                :label="$t('mail_template.technical_name')"
                :options="mailTechnicalKeyConst" />
            </div>
            <AkButtonFooterSidebar
              ref="footerSidebar"
              :cancelLabel="$t('cancel')"
              :validateLabel="$t('update')"
              @action="update"
              @cancel="hide" />
          </AkFormSubmitted>
        </perfect-scrollbar>
      </div>
    </template>
  </AkSidebar>
</template>
